//
// Copyright (c) 2011-2026 by Curalate, Inc.
//

import Cuid from '@models/Cuid';
import { RejectionCode } from '@models/RejectionCode';

export interface RejectionReasonDto {
  description: string;
  rejectionReasonId: number;
}

export interface RejectionReasonsResponse {
  data: RejectionReasonDto[];
}

export interface RejectModerationMediaRequest {
  cuids: Cuid[];
  rejectionReasonCode: RejectionCode;
}

export interface BatchUpdateModerationStatusRequest {
  contents: ModerationStatusInfo[];
}

export interface ModerationStatusInfo {
  cuid: Cuid;
  status: ModerationStatus;
  statusSource: ModerationStatusSource;
}

export enum ModerationStatus {
  Approved = 'Approved',
  Rejected = 'Rejected',
}

export enum ModerationStatusSource {
  AiEvaluation = 'AiEvaluation',
  AutoApprovedBrandAccount = 'AutoApprovedBrandAccount',
  AutoRejectedBrandAccount = 'AutoRejectedBrandAccount',
  AutoRejectedHashtag = 'AutoRejectedHashtag',
  UserOverride = 'UserOverride',
}
